import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="cancel-page" className="max-w-[600px] mx-auto px-6 py-24 text-center">
      <div className="label-eyebrow">Order cancelled</div>
      <h1 className="font-display text-4xl tracking-tighter mt-2">No worries.</h1>
      <p className="mt-4 text-neutral-500 text-sm">Your items are still in your bag whenever you're ready.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/cart" className="btn-primary">Back to bag</Link>
        <Link to="/" className="btn-outline">Home</Link>
      </div>
    </div>
  );
}
